import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

const fmtErr = (d) => {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
};

export default function AdminLogin({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("srs_admin_token", data.token);
      onSuccess();
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur"
        data-testid="admin-login-card"
      >
        <img src="/assets/logo-white.png" alt="SRS" className="mb-6 h-12 w-12 object-contain" />
        <h1 className="font-display text-2xl font-bold tracking-tight text-white">SRS Admin</h1>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">Sun Roofing Solutions · Mandya</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            data-testid="admin-login-email-input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            autoComplete="username"
            className="w-full rounded-xl border border-white/15 bg-transparent px-4 py-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-srs"
          />
          <input
            data-testid="admin-login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoComplete="current-password"
            className="w-full rounded-xl border border-white/15 bg-transparent px-4 py-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-srs"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-xs text-srs">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-srs px-4 py-3.5 font-mono text-[11px] uppercase tracking-[0.25em] text-white transition-colors hover:bg-srs-dark disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center font-mono text-[10px] uppercase tracking-[0.22em] text-white/30 hover:text-white">
          ← Back to site
        </Link>
      </motion.div>
    </div>
  );
}
